export const COLORS = {
    chartColorMain: 'rgba(255, 255, 255, 1)',
    chartColorLight: 'rgba(255, 255, 255, 0.4)'
}

export const FONTS = {
    title: {
        size: 14,
        family: 'Montserrat',
        weight: '700'
    },
    text: {
        size: 12,
        family: 'Montserrat',
        weight: '400'
    }
}

export function roundDataSet(dataSet) {
    return dataSet.map(value => value ? value.toFixed(1) : null)
}

function roundValue(value) {
    return value.toFixed(1)
}

export function formatTemperature(value) {
    return `${value} °C`
}

export function formatWaterLevel(value) {
    return value !== null ?
        `${roundValue(value)} cm`
        : null
}

export const LAKE_CHART_MODES = {
    week: "WEEK",
    month: "MONTH",
    year: "YEAR",
    max: "MAX"
}

export function formatTooltipTitle(context) {
    const labelObject = JSON.parse(context[0].label) //context[0].label is serialized
    return labelObject.tooltipValue
}

export function formatTooltipLabel(context) {
    let obj
    if (context.dataset.yAxisID === 'temperature') {
        obj = {
            name: 'Temperatura',
            value: formatTemperature(context.parsed.y)
        }
    } else {
        obj = {
            name: 'Poziom wody',
            value: formatWaterLevel(context.parsed.y)
        }
    }
    return JSON.stringify(obj)
}

export function filterEmptyLabels(value) { //value is serialized
    const labelObject = JSON.parse(this.getLabelForValue(value))
    return labelObject.axisValue ? labelObject.axisValue : null
}